// 展示用书名清洗：与后端 BookService.parseTitleAuthor 保持一致的兜底逻辑。
// 去掉“作者：xxx”后缀、(精校)/【完结】之类标签、包裹的《》，供首页/详情页/阅读器统一使用。
const TAG_RE = /[（(【\[][^）)】\]]{0,12}(精校|校对|全本|完结|完本|全集|下载|精校版|TXT|txt)[^）)】\]]{0,12}[）)】\]]/g

export function cleanTitle(raw) {
  let t = String(raw == null ? '' : raw).trim()
  t = t.replace(TAG_RE, '')
  t = t.replace(/作者[：:\s].*$/, '')
  t = t.replace(/[，,、\-—\s]+$/, '').trim()
  const m = t.match(/^《(.+)》$/)
  if (m) t = m[1].trim()
  return t || String(raw == null ? '' : raw).trim()
}

export default cleanTitle
